<template>
  <div
    id="pop-up-overlay"
    v-if="message !== null"
    v-on:click="clickedModal"
    v-on:keyup="keyHandler($event)"
    v-on:keypress="keyHandler($event)"
    v-on:keydown="keyHandler($event)"
  >
    <div class="pop-up" style="">
      <div style="font-size: larger; margin-bottom: 20px">
        {{ messageTitle }}
      </div>
      <div>{{ message }}</div>
      <div>
        <div class="col-xs-6 col-sm-4 pull-right" v-if="messageType !== 'e'">
          <input
            type="button"
            ref="runReport"
            class="btn btn-primary btn-block"
            :value="getContinueButtonTitle(messageType)"
            v-on:click="runReport()"
          />
        </div>
        <div class="col-xs-6 col-sm-4 pull-right">
          <input
            id="close-button"
            ref="goBack"
            type="button"
            class="btn btn-primary btn-block"
            :value="getCancelButtonTitle(messageType)"
            v-focus
          />
        </div>
        <!--<div v-if="messageType === 'e'" class="col-xs-6 col-sm-4 pull-right">
          <input id="close-button" ref="close" type="button" class="btn btn-secondary btn-block" value="Close" v-focus>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import store from "@/store";
import current from "@/scripts/current";
import common from "@/scripts/common";
import ctNavigation from "@/scripts/crossTabulation/navigation";
import lrNavigation from "@/scripts/logisticRegression/navigation";
import VariableSelection from "@/bo/VariableSelection";

export default {
  props: [],
  computed: {
    ...mapGetters({
      message: "display/getMessage",
      messageTitle: "display/getMessageTitle",
      messageType: "display/getMessageType",
      executionStats: "selModel/getExecutionStats",
    }),
    ...mapState({
      isReadyForNextStep: (state) => state.selModel.isReadyForNextStep,
    }),
    selectionModel: function () {
      return current.selectionModel;
    },
  },
  created: function () {},
  data: function () {
    return {};
  },
  methods: {
    getContinueButtonTitle: function (messageType) {
      switch (messageType) {
        case "e":
          return "Continue";
        case "w":
          return "Run Report";
        case "r":
          return "View Report";
        default:
          return "Continue";
      }
    },
    getCancelButtonTitle: function (messageType) {
      switch (messageType) {
        case "e":
          return "Close";
        case "w":
          return "Go Back";
        case "r":
          return "Delete Report";
        default:
          return "Cancel";
      }
    },
    keyHandler: function (e) {
      var vm = this;
      e.preventDefault();
      //if (e.type === 'keydown' && (e.code === 'Enter' || e.code === 'Space'))
      if (e.type !== "keydown") return;
      if (
        e.keyCode === common.keyCodes.Enter ||
        e.keyCode === common.keyCodes.Space
      ) {
        if (e.target === vm.$refs.runReport) vm.runReport();
        else checkForClose(vm.messageType, e.target, vm.$refs);
      } else if (
        e.keyCode === common.keyCodes.Tab ||
        e.keyCode === common.keyCodes.ArrowRight ||
        e.keyCode === common.keyCodes.ArrowUp ||
        e.keyCode === common.keyCodes.ArrowLeft ||
        e.keyCode === common.keyCodes.ArrowDown
      ) {
        if (e.target === vm.$refs.goBack) vm.$refs.runReport.focus();
        else if (e.target === vm.$refs.runReport) vm.$refs.goBack.focus();
      }
    },
    runReport: function () {
      const vm = this;
      var messageType = store.state.display.messageType;
      var navigation = current.navigation;
      if (messageType === "r") {
        //view Report
        if (store.state.results.analysisType === "ct") {
          current.initializeCrossTabulationValues(vm);
          navigation = ctNavigation;
        } else {
          current.initializeLogisticRegressionValues(vm);
          navigation = lrNavigation;
        }

        current.selectionModel = restoreSelectionModel(
          store.state.results.selectionModel
        );
        store.dispatch("selModel/restoreSelectionModel", {
          storeSelectionModel: store.state.results.storeSelectionModel,
        });
      }
      clearMessage();
      this.$router.push({ path: navigation.page.viewreport });
    },
    clickedModal: function (e) {
      var vm = this;
      e.preventDefault();
      checkForClose(vm.messageType, e.target, vm.$refs);
    },
    getSecondsStyle: function (seconds) {
      return seconds >= 60 ? "color: red;" : "";
    },
  },
};

function restoreSelectionModel(selectionModel) {
  var v = selectionModel.v;
  if (v.row) v.row = VariableSelection.createFromVariableSelection(v.row);
  if (v.column)
    v.column = VariableSelection.createFromVariableSelection(v.column);
  if (v.control1)
    v.control1 = VariableSelection.createFromVariableSelection(v.control1);
  if (v.control2)
    v.control2 = VariableSelection.createFromVariableSelection(v.control2);
  if (v.dependent) {
    v.dependent = VariableSelection.createFromVariableSelection(v.dependent);
  }
  if (v.independent) {
    for (var i = 0; i < v.independent.length; ++i) {
      v.independent[i] = VariableSelection.createFromVariableSelection(
        v.independent[i]
      );
    }
  }
  return selectionModel;
}

function clearMessage() {
  store.dispatch("display/setErrorMessage", {
    message: null,
    messageTitle: null,
  });
}
function checkForClose(messageType, target, $refs) {
  if (
    target === $refs.goBack ||
    (messageType !== "r" && target.id === "pop-up-overlay")
  ) {
    if (messageType === "r") store.dispatch("results/clearData", null);
    clearMessage();
  }
}
</script>

<style scoped>
.pop-up {
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: white;
  /*background-color: #C1D5B0;*/
  z-index: 1002;
  overflow: auto;
  width: 600px;
  height: auto;
  margin-left: -200px;
  margin-top: -200px;
  border-radius: 5px;
  border-width: medium;
  display: block;
  position: absolute;
  padding: 20px;
  /*z-index: 1002;
    width: 50%;
    height: auto;
    overflow: auto;
    background: rgb(255, 255, 255);
    z-index: 9999;
    left: 1px;
    margin-left: 20px;*/
}

.btn {
  margin-top: 20px;
  font-color: white;
}

@media (max-width: 767px) {
  .pop-up {
    width: 94%;
    margin-left: -47%;
  }
}

#pop-up-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
}
</style>
